var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7192 6.73599C12.7192 6.18371 12.2715 5.73599 11.7192 5.73599C11.167 5.73599 10.7192 6.18371 10.7192 6.73599V13.064C10.7192 13.4162 10.9045 13.7424 11.207 13.9228L16.129 16.8588C16.6033 17.1417 17.2171 16.9866 17.5001 16.5123C17.783 16.038 17.6278 15.4241 17.1535 15.1412L12.7192 12.4961V6.73599Z",
    fill: "#1B3DF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.071 4.92894C15.1658 1.02369 8.83418 1.02369 4.92893 4.92893C1.02369 8.83416 1.02369 15.1658 4.92893 19.071C8.83416 22.9763 15.1658 22.9763 19.071 19.071C22.9763 15.1658 22.9763 8.83418 19.071 4.92894ZM6.34314 6.34315C9.46734 3.21895 14.5327 3.21895 17.6568 6.34314C20.781 9.46734 20.781 14.5327 17.6568 17.6568C14.5326 20.781 9.46732 20.781 6.34315 17.6568C3.21895 14.5326 3.21895 9.46732 6.34314 6.34315Z",
    fill: "#1B3DF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsClock);
export default __webpack_public_path__ + "static/media/icons-clock.423f500bc11fa3d5ac063db7e5c168e0.svg";
export { ForwardRef as ReactComponent };